S.stageSwiper = {
    config: {
        loop: true,
    },

    elements: {
        $swiperContainer: null,
        $swiperPagination: null,
    },

    $swiper: null,

    init()
    {
        this.initSwiper();
    },

    initSwiper()
    {
        this.$swiper = new Swiper(this.elements.$swiperContainer, {
            // per css config
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
            speed: 500,
            centeredSlides: false,
            calculateHeight: true,
            loop: this.config.loop,

            keyboard: {
                enabled: true,
            },

            pagination: {
                el: this.elements.$swiperPagination,
                clickable: true,
            },

            navigation: {
                nextEl: this.$module.find('.swiper-button-next'),
                prevEl: this.$module.find('.swiper-button-prev'),
            },

            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: true,
        });
    },
};
